var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutralGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    d: "M24 48C10.745 48 0 37.255 0 24S10.745 0 24 0s24 10.745 24 24-10.745 24-24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M15 23a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM33 23a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM14 34h20a1 1 0 0 1 1 1c0 .608-.386 1.149-.96 1.347-3.354 1.156-6.7 1.734-10.04 1.734-3.34 0-6.686-.578-10.04-1.734A1.425 1.425 0 0 1 13 35a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.493 7.338l-.097.403a1 1 0 0 1-.522.659c-1.335.674-2.533 1.67-3.593 2.988C8.113 12.84 6.924 15.2 5.71 18.47c.082-2.847.697-5.218 1.846-7.113 1.041-1.716 2.82-3.214 5.335-4.494a.421.421 0 0 1 .6.474z",
    opacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralGrey);
export default __webpack_public_path__ + "static/media/neutral-grey.3cd85b0f.svg";
export { ForwardRef as ReactComponent };